<template>
    <div class="admin-actions" v-if="user.permission === 'adm_sys' && boUrl">
        <span>
            <a :href="editUrl" target="_blank">
                <action
                    name="link"
                    :nochevron="true"
                    :small="true"
                    with-icon="mdi-pencil"
                    color-icon="#0052FF"
                >
                    Modifer
                </action>
            </a>
        </span>
    </div>
</template>

<script>
export default {
    props: ["convention", "user"],
    data() {
        return {
            sticky: false,
            boUrl: window.process.env.APP_DIODE_BO_URL,
        };
    },
    computed: {
        editUrl() {
            if (this.convention && this.convention.id) {
                return `${this.boUrl}/conventions/${this.convention.id}/edit/0`;
            }
            return "";
        },
    },
};
</script>

<style scoped lang="sass">
.admin-actions
    display: flex
    justify-content: flex-end

@media print
    .admin-actions
        display: none
</style>
